<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <product-listing-create
      :ams_template="ams_template"
      :reroute="reroute"
    ></product-listing-create>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ProductListingCreate from './ProductListingCreate.vue'

export default {
  components: {
    VuexBreadcrumb,
    ProductListingCreate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  }
}
</script>